<template>
  <div class="allgroup-container">
    <ul>
      <li class="group-item"
          v-for="(item, index) in channelGroupVoList"
          :key="index"
          :class="{active: item.groupId === currentGroup.groupId}"
          @click="swicthGroup(item)"
      >
        {{index + 1}} . <span class="text">{{item.groupName}}</span>
        <span style="margin-left: 20px;color: red" v-if="item.unreadMsgCount">{{item.unreadMsgCount}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import { mapState } from 'vuex'
export default {
  inject: ['selectedSkill'],
  data () {
    return {}
  },
  computed: {
    ...mapState({
      channelGroupVoList: 'channelGroupVoList', // 所有技能组
      currentGroup: 'currentGroup', // 当前技能组
      visitorInfo: 'visitorInfo'
    })
  },
  methods: {
    swicthGroup (item) {
      let params = {
        tenantId: this.visitorInfo.tenantId,
        groupId: item.groupId,
        visitorId: this.visitorInfo.visitorId,
      }
      ajax.get(apis.chat.resetUnReadCount, {params}).then((res) => {
        if (res.success) {}
        this.selectedSkill(item)
      })
    }
  }
}
</script>
<style scoped lang="less">
  .allgroup-container{
    width: 200px;
    .group-item{
      height: 40px;
      border-bottom: 1px solid #ddd;
      line-height: 40px;
      cursor: pointer;
      padding-left: 10px;
      &.active{
        background-color: #E4ECFF;
      }
      &:hover{
        background-color: #E4ECFF;
      }
    }
  }
</style>
